<script lang="ts">
  import { Button } from '../../button';
  import { Minus, Plus } from 'phosphor-svelte';
  import { icon } from '@agapi/ui/panda/patterns';
  import type { QuantitySelectorButtonProps } from '../quantity-selector.types';
  import { css } from '@agapi/ui/panda/css'
  import { buttonStyles } from '../../button/button.styles';

  const {
    value,
    attributes,
    onclick,
    size,
    disabled,
    css: cssProp
  }: QuantitySelectorButtonProps = $props();


</script>

<button {...attributes} disabled={disabled} class={css(buttonStyles.raw({size}), cssProp)} onclick={onclick}>
  {#if value === -1}
    <Minus weight="bold" class={icon({ size })}/>
  {:else if value === 1}
    <Plus weight="bold" class={icon({ size })}/>
  {/if}
</button>
